import React from 'react';
import { setCookie } from '../cookie/cookies';
import axios from 'axios';
import '../assets/styles/Header.css';
import { useNavigate } from 'react-router-dom';

import cart from '../assets/images/cart.png';

function Header(props) {
    let navigate = useNavigate();

    const routeChange = (isInternal, path, e) => {
        e.preventDefault();
        if (isInternal) {
            let newPath = path;
            navigate(newPath);
        } else {
            window.open(path);
        }
    };

    return (
        <div className='header'>
            <div className='title'>{props.header}</div>

            <div
                className='cart'
                onClick={(e) => routeChange(true, '/cart', e)}
            >
                <img className='cart-image' src={cart} />
            </div>
        </div>
    );
}

export default Header;
